import { render, staticRenderFns } from "./readonly.vue?vue&type=template&id=1fd2880c"
import script from "./readonly.vue?vue&type=script&lang=ts"
export * from "./readonly.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports